import React from 'react';
import PropTypes from 'prop-types';

/** renders a form title */
const FormTitle = ({
  children,
  className
}) => {

  return (
    <div className={`form-title ${className || ''}`}>
      {children}
    </div>
  );
};

FormTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default FormTitle;
